import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from "./components/App";


// Punto de entrada principal de React.
// HelmetProvider permite manejar:
// - títulos dinámicos
// - meta descriptions
// - Open Graph
// - SEO dinámico
// desde cualquier página.
createRoot(document.getElementById('root')).render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);